import React, { FC } from "react";
import Image from "next/image";
import styles from "./Person.module.scss";

export interface PersonProps {
  image: string | StaticImageData,
  name: string,
  href?: string,
}

const Person: FC<PersonProps> = ({
  image,
  name,
  href,
  children,
}) => (
  <div className={styles.person}>
    <a className={styles.pictureWrapper} href={href} target='_blank' rel="noreferrer">
      <Image
        src={image as string}
        alt={name}
        width={165}
        height={165}
        className={styles.picture}
        layout="fixed"
      />
    </a>
    <p className={styles.name}>{name}</p>
    <p className={styles.bio}>{children}</p>
  </div>
)

export default Person